import { instance } from '../api/api';
import { ITariff, ITariffResponse, ITariffCreateRequest, ITariffUpdateRequest } from '../types/type';

export interface TariffFilters {
  page?: number;
  limit?: number;
}

export const TariffService = {
  async getTariffs(filters: TariffFilters = {}): Promise<ITariffResponse> {
    try {
      const queryParams = new URLSearchParams();

      // Добавляем параметры в URL
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value.toString());
        }
      });

      const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
      const { data } = await instance.get<ITariffResponse>(`/tariffs${queryString}`);

      return data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Не удалось получить тарифы');
    }
  },

  async createTariff(tariff: ITariffCreateRequest): Promise<ITariff> {
    try {
      const { data } = await instance.post<ITariff>('/tariffs', tariff);
      return data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Не удалось создать тариф');
    }
  },

  async updateTariff(id: string, tariff: ITariffUpdateRequest): Promise<ITariff> {
    try {
      const { data } = await instance.put<ITariff>(`/tariffs/${id}`, tariff);
      return data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Не удалось обновить тариф');
    }
  },

  async deleteTariff(id: string): Promise<void> {
    try {
      await instance.delete(`/tariffs/${id}`);
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Не удалось удалить тариф');
    }
  },
};
